/**
 * Supported accounting software types for syncing with Plooto
 * @constant
 */
const SupportedAccountingSoftware = {
  NetSuite: 'netsuite',
  QuickBooksDesktop: 'quickbooksdesktop',
  QuickBooksOnline: 'quickbooksonline',
  Xero: 'xero',
} as const;

type SupportedAccountingSoftwareType =
  (typeof SupportedAccountingSoftware)[keyof typeof SupportedAccountingSoftware];

export type { SupportedAccountingSoftwareType };
export { SupportedAccountingSoftware };
